import * as React from 'react';
import styled from 'styled-components';

import QuestionContainer from 'src/SharedComponents/QuestionContainer';

import { useEffect } from 'react';
import AlternateAnswerOption from './AlternteAnswerOption';

interface ITitleProps {
    textAlign: string
};

const QuestionText = styled.p`
    text-align: ${(props: ITitleProps) => props.textAlign};
    font-size: 1.5em;
    margin-bottom: 20px;
`;

const Subheading = styled.h2`
    text-transform: uppercase;
    text-align: center;
    font-weight: normal;
    font-size: 1rem;
    margin: 0;
`;

const AnswerContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    justify-content: space-evenly;
`;


interface IProps {
    answers: string[],
    alternateColour?: boolean,
    hidden?: boolean,
    onAnswerChange: (questionId: number, answer: string, itemIndex?: number) => void,
    question: string,
    questionId: number,
    refProp?: React.RefObject<HTMLLIElement>,
    subheading?: string,
    titleAlign?: string,
    checkedItem?: number,
    preheading?: string,
};

const AlternateMultipleChoiceQuestion = (props: IProps) => {
    const { alternateColour, answers, hidden, onAnswerChange, question, questionId, refProp, subheading, titleAlign, preheading } = props;
    const [checkedItem, setCheckedItem] = React.useState(props.checkedItem);

    useEffect(() => {
        setCheckedItem(props.checkedItem);
    }, [props.checkedItem]);

    const checkItem = (itemNumber: number) => (isChecked: boolean) => {
        if (isChecked) {
            onAnswerChange(questionId, answers[itemNumber], itemNumber);
        } else {
            onAnswerChange(questionId, "", -1);
        }
    };

    return <QuestionContainer ref={refProp} className={alternateColour ? "alternate" : ""} hidden={!!hidden}>
        {preheading && <Subheading>{preheading}</Subheading>}
        {question && <QuestionText textAlign={titleAlign || "left"}>{question}</QuestionText>}
        {subheading && <Subheading>{subheading}</Subheading>}
        <AnswerContainer style={{ flexDirection: "column", width: "70%", margin: "auto" }}>
            {answers.map((answer, index) => <AlternateAnswerOption answer={answer} key={`question-${questionId}-answer-${index}`} checked={checkedItem === index} onChange={checkItem(index)} />)}
        </AnswerContainer>
    </QuestionContainer>
};

export default AlternateMultipleChoiceQuestion;



// WEBPACK FOOTER //
// ./src/SharedComponents/AlternateMultipleChoiceQuestion.tsx